import { Button, Col, Row, Typography } from "antd";
import { StyleSheet } from "../StyleSheet";
import { Link } from "react-router-dom";
import { imagesWithState, imagesWithoutState } from "./ImagesMenu";
import stylesCss from "./css/images.module.css";
import { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import SecuritySeal from "./SecuritySeal";

const { Text } = Typography;

interface PaymentFormsProps {
    showSeal?: boolean;
}

const PaymentForms = ({ showSeal = true }: PaymentFormsProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            {showSeal && <SecuritySeal />}
            <Row justify={'center'} style={{ padding: '15px 0', marginBottom: 50, display: 'flex', flexDirection: 'row' }}>
                <Row wrap={false} align={'middle'} style={{ marginTop: 40, display: 'flex', justifyContent: 'center', width: '100%', padding: '10px 0' }}>
                    <Text style={styles.textTitle} className="page-title">
                        Otras formas de Pago
                    </Text>
                    <Col style={{ marginLeft: 8, display: 'flex', justifyContent: "end", alignItems: 'center' }}>
                        <Button
                            icon={
                                isExpanded ? (
                                    <UpOutlined style={{ color: "#007aff", fontSize: 20 }} />
                                ) : (
                                    <DownOutlined style={{ color: "#007aff", fontSize: 20 }} />
                                )
                            }
                            onClick={() => setIsExpanded(!isExpanded)}
                            type="text"
                        />
                    </Col>
                </Row>
                {isExpanded && (
                    <>
                        <Row style={{ marginTop: 10, display: 'flex', justifyContent: 'center', flexDirection: 'row' }} className={stylesCss.text} justify={'center'}>
                            <Col style={styles.divContainer}>
                                <Text style={styles.textTitle2} className="page-subtitle">
                                    Cargo Automático a tu Tarjeta de Crédito o Débito
                                </Text>
                                <Text style={styles.text} className="page-text">
                                    Desde la página de&nbsp;
                                    <Link
                                        style={{ color: "#1786ff" }}
                                        to={"https://sel.megacable.com.mx/"}
                                        target='_blank'
                                    >
                                        Mi Cuenta
                                    </Link>
                                    &nbsp;MEGA, la Megacable App, también lo puedes hacer visitando
                                    tu CIS más cercano o llama por teléfono al 33 9690 0000, proporciona los datos de tu tarjeta
                                    y mensualmente se te procesará tu pago de forma automática y segura.
                                </Text>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 35, display: 'flex', justifyContent: 'center' }} className={stylesCss.text} justify={'center'}>
                            <Col style={styles.divContainer}>
                                <Text style={styles.textTitle2} className="page-subtitle">
                                    Centros de pago
                                </Text>
                                <Text style={styles.text} className="page-text">
                                    También puedes pagar en tu Centro de Atención al Cliente, consulta <Link
                                        style={{ color: "#1786ff" }}
                                        to={'https://www.megacable.com.mx/centros-de-atencion'}
                                        target='_blank'
                                    >AQUÍ TU CIS</Link> más cercano.
                                    Y para tu comodidad y para que ahorres tiempo, contamos con más de 10,000 opciones donde puedes realizar tu pago mensual.
                                    Ya sea con tu Estado de cuenta o con tu número de suscriptor a 10 dígitos.
                                </Text>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 25, display: 'flex', justifyContent: 'center' }} className={stylesCss.text}>
                            <Col style={styles.divContainer}>
                                <Text style={styles.textDownload} className="page-text">
                                    DESCARGA TU ESTADO DE CUENTA&nbsp;
                                    <Link
                                        style={{ color: "#1786ff" }}
                                        to={'https://sel.megacable.com.mx/'}
                                        target='_blank'
                                    >
                                        AQUÍ
                                    </Link>
                                </Text>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 35, display: 'flex', justifyContent: 'center' }} className={stylesCss.text} justify={'center'}>
                            <Col style={styles.divContainer}>
                                <Text style={styles.textTitle2} className="page-subtitle">
                                    CON ESTADO DE CUENTA
                                </Text>
                                <Text style={styles.text} className="page-text">
                                    Visita tu CIS más cercano o llama por teléfono, proporciona los datos de tu tarjeta y
                                    mensualmente se te procesará tu pago de forma automática y segura.
                                </Text>
                            </Col>
                        </Row>
                        <div style={{ marginTop: 30, marginBottom: 20 }} className={stylesCss.logosGrid}>
                            {imagesWithState.map((element, index) => (
                                <div key={index} className={stylesCss.logoBox}>
                                    <img
                                        src={element.icon}
                                        alt={element.title}
                                        className={stylesCss.logo}
                                    />
                                </div>
                            ))}
                        </div>
                        <Row style={{ marginTop: 50, display: 'flex', justifyContent: 'center' }} className={stylesCss.text} justify={'center'}>
                            <Col style={styles.divContainer}>
                                <Text style={styles.textTitle2} className="page-subtitle">
                                    SIN ESTADO DE CUENTA
                                </Text>
                                <Text style={styles.text} className="page-text">
                                    Para tu comodidad y para que ahorres tiempo, contamos con más de 10,000 opciones donde
                                    puedes realizar tu pago mensual.
                                </Text>
                            </Col>
                        </Row>
                        <div style={{ marginTop: 35 }} className={stylesCss.logosGrid}>
                            {imagesWithoutState.map((element, index) => (
                                <div key={index} className={stylesCss.logoBox}>
                                    <img
                                        src={element.icon}
                                        alt={element.title}
                                        className={stylesCss.logo}
                                    />
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </Row>
        </>
    )
};

const styles = StyleSheet.create({
    textTitle: {
        color: '#007aff',
        fontWeight: "500",
        textAlign: 'center'
    },
    divContainer: {
        flexDirection: "column",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textTitle2: {
        color: 'black',
        fontWeight: "bold",
        textAlign: 'center'
    },
    text: {
        color: '#212529',
        fontWeight: 400,
        textAlign: 'center',
        marginTop: 5
    },
    cards: {
        height: 60,
        marginTop: "2rem"
    },
    textDownload: {
        color: '#212529',
        fontWeight: 400,
        textAlign: 'center',
        marginTop: 5
    }
});

export default PaymentForms;